/**
 * Configuration centrale des liens d'affiliation.
 * ⚠️ NE JAMAIS modifier le paramètre ID_PARRAIN — c'est l'identifiant
 * de parrainage qui permet de percevoir la commission.
 */
export const AFFILIATES = {
  meilleurtaux: {
    credit: {
      url: "https://www.meilleurtaux.com/demande-simulation/credit-immobilier/?ID_PARRAIN=VDEV4MS",
      partner: "Meilleurtaux",
      productName: "Crédit immobilier",
    },
    assurance: {
      url: "https://www.meilleurtaux.com/demande-simulation/assurance-de-pret/?&ID_PARRAIN=VDEV4MS",
      partner: "Meilleurtaux",
      productName: "Assurance de prêt",
    },
  },
} as const;

export type AffiliateVariant = "credit" | "assurance";

export function getAffiliate(variant: AffiliateVariant) {
  return variant === "credit"
    ? AFFILIATES.meilleurtaux.credit
    : AFFILIATES.meilleurtaux.assurance;
}

import { trackEvent } from "@/lib/analytics";

/**
 * Tracker de clics sur liens affiliés via Plausible (anonyme, RGPD-safe).
 */
export function trackAffiliateClick(
  partner: string,
  product: string,
  placement: string
) {
  trackEvent("affiliate_click", { partner, product, placement });
}
